import AuthForm from "../AuthForm";

export default function Register() {
  return <AuthForm mode="register" />;
}
